const getters = {
  getApiKey: state => state.apiKey,
}

export default getters
